const svgCache = new Map();

function fetchSvg(url) {
  if (!url) return Promise.resolve("");
  if (!svgCache.has(url)) {
    const promise = fetch(url, { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch SVG: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const start = text.indexOf("<svg");
        return start >= 0 ? text.slice(start) : "";
      })
      .catch(() => "");
    svgCache.set(url, promise);
  }
  return svgCache.get(url);
}

async function hydrateSvg(node) {
  if (!(node instanceof HTMLElement)) return;
  if (node.dataset.inlineSvgHydrated === "true") return;

  const url = node.dataset.inlineSvgUrl;
  if (!url) return;

  const markup = await fetchSvg(url);
  if (!markup) {
    node.dataset.inlineSvgReady = "error";
    node.style.visibility = "visible";
    return;
  }

  node.innerHTML = markup;
  const svg = node.querySelector("svg");
  if (svg) {
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    svg.removeAttribute("width");
    svg.removeAttribute("height");
  }

  node.dataset.inlineSvgHydrated = "true";
  node.dataset.inlineSvgReady = "true";
}

function hydrateAll(root = document) {
  root.querySelectorAll("[data-inline-svg-url]").forEach((node) => {
    hydrateSvg(node);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => hydrateAll(), { once: true });
} else {
  hydrateAll();
}

document.addEventListener("shopify:section:load", (event) => {
  hydrateAll(event.target);
});
